import styles from './MinusIcon.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function MinusIcon({className}) {
  const classNameArray = className?.split(' ') || [];

	return (
		<svg className={cx(['minus-icon', ...classNameArray])} width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<rect width="40" height="40" rx="19.8128" fill="#202020" />
			<path d="M9.38414 20.1402H31.5635" stroke="white" strokeWidth="4.43333" strokeLinecap="round" />
		</svg>
	);
}
